import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 LemmonTags. Todos los derechos reservados.</p>
    </footer>
  );
}

export default Footer;